// Cliente de la revisión de accesos de emergencia al expediente (MT-042, break-glass; ver packages/web/src/api/http-routes/hce-acceso-emergencia.ts).
// Siempre con el token del administrador del HCE (hceAdminSession.ts): el Responsable de privacidad es el propio administrador del consultorio.
import { vaultUrl } from './hceVault';
import { bearer } from './hceAuditoria';

export type EmergenciaAcceso = {
  id: number;
  profesional: string | null;
  practitionerId: string;
  /** Id FHIR del paciente; la pantalla lo muestra como la bitácora (`Patient/<id>`). */
  pacienteFhirId: string;
  motivo: string;
  desde: number;
  hasta: number;
  revisadoAt: number | null;
  revisadoPor: string | null;
  notaRevision: string | null;
};

async function pedirLista(token: string, query: string): Promise<{ filas: EmergenciaAcceso[]; hayMas: boolean }> {
  const res = await fetch(vaultUrl(`/api/hce/acceso-emergencia?${query}`), { headers: bearer(token) });
  if (!res.ok) throw new Error('No se pudo cargar la lista de accesos de emergencia.');
  const body = await res.json();
  return { filas: body.emergencias as EmergenciaAcceso[], hayMas: body.hayMas === true };
}

/** TODAS las pendientes de revisión (el servidor no las recorta por antigüedad). */
export async function listarPendientes(token: string): Promise<EmergenciaAcceso[]> {
  return (await pedirLista(token, 'pendientes=1')).filas;
}

/** Las revisadas, de a una página (50); `antesDeId` pide la siguiente (las de id menor). */
export async function listarRevisadas(token: string, antesDeId?: number): Promise<{ filas: EmergenciaAcceso[]; hayMas: boolean }> {
  return pedirLista(token, `revisadas=1&limite=50${antesDeId ? `&antes=${antesDeId}` : ''}`);
}

export async function marcarEmergenciaRevisada(token: string, id: number, nota: string): Promise<void> {
  const res = await fetch(vaultUrl(`/api/hce/acceso-emergencia/${id}/revisar`), { method: 'POST', headers: bearer(token), body: JSON.stringify({ nota }) });
  if (!res.ok) {
    const cuerpo = await res.json().catch(() => ({}));
    throw new Error(typeof cuerpo?.error === 'string' ? cuerpo.error : 'No se pudo marcar como revisado.');
  }
}

/** Vigencia para mostrar: «vigente» mientras no vence. */
export function vigenciaDe(hasta: number, ahora: number = Date.now()): 'vigente' | 'vencido' {
  return hasta > ahora ? 'vigente' : 'vencido';
}
